module.exports = __webpack_public_path__ + "img/icon-info.ac23c075.svg";